<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="getSaveCode">{{saveCode()}}</div>
        <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>

        <v-card class="shadow-none" v-if="loaded">
            <v-card-text>
                <xReadContent v-bind:id='20000' v-bind:format='"array"' v-bind:my_elementA="dcontent.data.content" 
                              v-bind:runnable='true' v-bind:task_id ='dcontent.task_id' v-bind:user_course_id = "dcontent.user_course_id"/>
            </v-card-text>
            <v-card-text>
                <v-textarea
                    @blur="saveCode()"
                    v-model="dataAnswer"
                    filled
                    flat
                    label="Your answer:"
                    outlined
                    :rows="8"                    
                ></v-textarea>
            </v-card-text>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs3>
                        <v-btn v-for="(answer, index) in essayAnswers" :key="index" class="background-transparent" style="width:100%" @click="recentAnswer = answer.answers.substring(2,answer.answers.length-2); recentComment = answer.info">
                            {{answer.time_stamp}} - {{answer.score}} / {{answer.max_score}}  
                            <v-spacer></v-spacer> 
                            <v-icon v-if="answer.info.length>0">done</v-icon>                          
                        </v-btn>
                        
                    </v-flex>
                    <v-flex xs9>
                        <v-textarea
                        v-if="recentAnswer.length>0"
                            label="Recent answer:"
                            v-model="recentAnswer"
                            outlined
                            readonly
                            :rows="8"                    
                        ></v-textarea>
                        <v-textarea
                        v-if="recentComment.length>0"
                            label="Comment:"
                            v-model="recentComment"
                            outlined
                            readonly
                            :rows="6"                    
                        ></v-textarea>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import * as logs from '../../assets/log_process.js'
import xReadContent from '../../components/jprcomponents/etype_xread_content.vue'
import {mapGetters} from 'vuex'
import axios from './../../axios-auth'

export default {
    data() {
        return {
            startTime : null,
            dataAnswer: null,
            lastCode: null,
            answerList: null,
            loaded: false,
            task_id: 0,
            activity_type: '',
            essayAnswers: [],
            recentAnswer: '',
            recentComment: ''
        }
    },
    computed: 
        mapGetters([
                'getSaveCode',
                'getCheckAnswerEvent'
        ]),    
    props: {
        dcontent: Object,
        taskIndex: Number
    },
    components: {
        xReadContent
    },
    mounted() {
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
        // write passed
        if (!this.dcontent.passed) {
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: 0})            
        }
        this.initData()
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    },
    methods: {
        saveCode() {
            this.$store.commit('setSaveCode',false)
            let _changed = false // new
            let _not_empty = false // new
            if (this.dataAnswer != null && this.dataAnswer != '') _not_empty = true // new ak to zblbne a nenacita je to prazdne
            if (this.dataAnswer != this.lastCode)  _changed = true // new


            if (_not_empty && _changed) { // new
                const _d = {
                    _name: this.activity_type,
                    _content: this.dataAnswer
                }
                const data = {
                    task_id : this.task_id,
                    activity_type: this.activity_type,
                    files: JSON.stringify(_d),
                }
                // this.loaded = false // new toto som zrusil
                axios.post('/save-program3', data, this.$store.getters.getAxiosConfig )
                .then(() => {
                    // set data to var                
                    // this.loaded = true // new toto som zrusil
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
            } else {
               // console.log('naprazdno')
            }

        },
        initData() {
            // read attempts
            this.activity_type = 'essay'
            this.task_id = this.dcontent.task_id
            const _data = {
                activity_type: this.activity_type
            }

            axios.post('/load-program3/' + this.task_id, _data, this.$store.getters.getAxiosConfig )
            .then((res) => {
                // set data to var
                // console.log(res.data)
                const data = (res.data.code == null) ? '' : res.data.code

                try {
                    if (data.length > 2) {
                        const d = JSON.parse(data)                    
                        this.dataAnswer = "" + d._content
                        this.lastCode = "" + this.dataAnswer
                    }
                } catch (err) {
                    this.dataAnswer = ""
                    this.lastCode = ""
                }
                this.loaded = true
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })        
            this.getMyAnswers() 
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent',false) 

            // send info to server
            let answerList = [ this.dataAnswer ]
            const data = {
                task_id : this.dcontent.task_id,
                time_length: Math.floor((new Date() - this.startTime)/1000 + 0.5),
                task_type_id: this.dcontent.task_type_id,
                answer_list : JSON.stringify(answerList),
                activity_type: this.activity_type
            }
            axios.post('/task-evaluate2', data, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useEvaluation(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },
        useEvaluation(myData) {
            this.$store.commit('setWaitingForResult',false) // data was delivered
        //    this.$store.commit('setTaskRating',myData.result.rating/20) // for backdrop
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: myData.result.rating})
            this.$store.commit('setUserPerformance',myData.user)
            this.getMyAnswers()     
            this.$store.commit('setFeedback', 'This is info: Saved succesfully')
        },           
        getMyAnswers() {
            const _data = {
                task_id : this.task_id
            }
            axios.post('/get-my-answers', _data, this.$store.getters.getAxiosConfig )
            .then((res) => {
                this.essayAnswers = res.data
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
            }
    }
}
</script>
